import { Menu, MenuButton, MenuItem, MenuItems, MenuSeparator } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { Link, useLocation } from '@tanstack/react-router'
import { twJoin } from 'tailwind-merge'
import { HeaderAppLogoBlack } from '../HeaderApp/HeaderAppLogo'
import type { PrimaryNavigationProps } from '../types'

type Props = {
  menuItems: PrimaryNavigationProps['secondaryNavigation']
  logo: boolean
}

export const NavigationDesktopMenu = ({ menuItems, logo }: Props) => {
  const { pathname } = useLocation()

  return (
    <Menu as="div" className="relative isolate z-50 pr-0">
      {({ open }) => (
        <div className="contents">
          <MenuButton className="inline-flex items-center justify-center rounded-md border border-gray-700 p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:ring-2 focus:ring-white focus:outline-none focus:ring-inset">
            <span className="sr-only">Sekundärmenü öffnen</span>
            {open ? (
              <XMarkIcon className="size-6" aria-hidden="true" />
            ) : (
              <Bars3Icon className="size-6" aria-hidden="true" />
            )}
          </MenuButton>
          <MenuItems
            anchor="bottom end"
            transition
            className="z-50 mt-1 w-48 origin-top-right divide-y divide-gray-100 rounded-md bg-white py-1 shadow-lg outline-1 outline-black/5 transition duration-100 ease-out data-closed:scale-95 data-closed:opacity-0"
          >
            {menuItems.map((group, i) => {
              return (
                // oxlint-disable-next-line react/no-array-index-key -- OK here
                <div className="p-1" key={i}>
                  {group.map((item, gi) => {
                    const current = pathname === item.to
                    return (
                      // oxlint-disable-next-line react/no-array-index-key -- OK here
                      <MenuItem key={gi}>
                        {({ focus }) => (
                          <Link
                            to={item.to}
                            hash={item.hash}
                            className={twJoin(
                              focus ? 'bg-gray-100' : '',
                              current ? 'bg-gray-200' : '',
                              'block px-4 py-2 text-sm text-gray-700',
                            )}
                          >
                            {item.name}
                          </Link>
                        )}
                      </MenuItem>
                    )
                  })}
                </div>
              )
            })}
            {logo && (
              <>
                <MenuSeparator />
                <div className="flex items-center justify-center px-1 py-3">
                  <HeaderAppLogoBlack />
                </div>
              </>
            )}
          </MenuItems>
        </div>
      )}
    </Menu>
  )
}
